import CityPageTemplate from "../city-template/CityPageTemplate";
import { newBraunfelsConfig } from "./data";

export default function NewBraunfelsPage() {
  return <CityPageTemplate config={newBraunfelsConfig} />;
}